module.exports = __webpack_public_path__ + "a9bed017984a258097841902b696a7a6.ttf";